<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
      <el-form-item label="奖章名" prop="specialName">
        <el-input v-model="dataForm.specialName" placeholder="奖章名"></el-input>
      </el-form-item>
      <el-form-item label="奖章图片" prop="imgUrl">
        <el-upload
                class="avatar-uploader"
                :action="uploadUrl"
                :show-file-list="false"
                :on-success="uploadSuccessHandle"
                :before-upload="uploadBeforeUploadHandle">
          <img v-if="dataForm.imgUrl" :src="dataForm.imgUrl" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <!-- <el-upload
                 style="width: 100px;height: 100px"
                 class="avatar-uploader"
                 :action="uploadUrl"
                 :show-file-list="false"
                 :on-success="uploadSuccessHandle"
                 :before-upload="uploadBeforeUploadHandle">
           <img v-if="dataForm.imgUrl" :src="dataForm.imgUrl" style="width: 100px;height: 100px" class="avatar">
           <i v-else class="el-icon-plus avatar-uploader-icon" style="width: 100px;height: 100px"></i>-->
      </el-form-item>

      <el-form-item label="主题" prop="theme">
        <el-input v-model="dataForm.theme" placeholder="主题"></el-input>
      </el-form-item>
      <el-form-item label="教育要点" prop="educationPoint">
        <el-input v-model="dataForm.educationPoint" placeholder="教育要点"></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import Cookies from 'js-cookie'
export default {
  data () {
    return {
      visible: false,
      uploadUrl: '',
      dataForm: {
        id: '',
        typeId: '',
        typeName: '',
        specialName: '',
        imgUrl: '',
        theme: '',
        educationPoint: '',
        creator: '',
        updater: '',
        createDate: '',
        updateDate: '',
        schoolId: '',
        decorationLevel: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        specialName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.uploadUrl = `${window.SITE_CONFIG.apiURL}/sys/oss/upload?token=${Cookies.get('token')}`
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
        if (this.dataForm.id.length) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get('/xytsz/specialDecoration/' + this.dataForm.id).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 上传图片之前
    uploadBeforeUploadHandle (file) {
      if (file.type !== 'image/jpg' && file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/gif') {
        this.$message.error(this.$t('upload.tip', { format: 'jpg、png、gif' }))
        return false
      }
    },
    // 上传图片成功
    uploadSuccessHandle (res, file, fileList) {
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      }
      this.dataForm.imgUrl = res.data.src
      console.log(this.dataForm.imgUrl)
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/xytsz/specialDecoration/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { leading: true, trailing: false })
  }
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
